import React, { Component } from "react";
import InputMask from "react-input-mask";

import UI from "../../../actions/ui-helper";
import API from "../../../actions/api-helper";
import DataUtil from "../../../actions/data.js";

import ImportacaoForm from "./ImportacaoForm";

class Importacao extends Component {
  constructor(props) {
    super(props);
    this.state = {
      consulta: {
        cadastroDe: DataUtil.primeiroDiaMes(),
        cadastroAte: DataUtil.hoje(),
        participanteId: 0,
        paciente: "",
      },
      usuarios: [],
      resultado: [],
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    API.get("/usuarios/ativos").then(
      function (json) {
        // Cria uma lista simplificada de usuários à vincular ...
        let usuarios = [{ id: 0, nome: "TODOS" }];
        json.data.forEach((usuario) => {
          usuarios.push({
            id: usuario.id,
            nome: usuario.nome,
          });
        });
        this.setState({ usuarios: usuarios });
      }.bind(this)
    );
  }

  handleSubmit(event) {
    event.preventDefault();

    let data = this.state.consulta;
    if (!DataUtil.validarData(data.cadastroDe)) {
      data.cadastroDe = "01/01/2000";
    }
    if (!DataUtil.validarData(data.cadastroAte)) {
      data.cadastroAte = DataUtil.hoje();
    }

    UI.loader("show", "Um momento...");
    API.post("/atendimentos/consulta", data)
      .then(
        function (json) {
          this.setState({ resultado: json.data });
          UI.loader("hide");
        }.bind(this)
      )
      .catch(function (json) {
        UI.alert(false, json.message);
        UI.loader("hide");
      });
  }

  handleChange(event) {
    let consulta = this.state.consulta;
    consulta[event.target.name] = event.target.value;

    this.setState({ consulta: consulta });
  }

  render() {
    return (
      [<ImportacaoForm />],
      [
        <form
          className="form-sample"
          autoComplete="off"
          spellCheck="false"
          onSubmit={this.handleSubmit}
        >
          <div className="row">
            <div className="col-12 grid-margin">
              <div className="card">
                <div className="card-body">
                  <h4 className="card-title">HISTÓRICO DE IMPORTAÇÃO</h4>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group row">
                        <div className="col-md-3">
                          <label>Importado Desde</label>
                          <InputMask
                            placeholder="IMPORTADO DE"
                            name="importadoDe"
                            className="form-control"
                            mask="99/99/9999"
                            value={this.state.consulta.importadoDe}
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="col-md-3">
                          <label>Importado Até</label>
                          <InputMask
                            placeholder="IMPORTADO ATÉ"
                            name="importadoAte"
                            className="form-control"
                            mask="99/99/9999"
                            value={this.state.consulta.importadoAte}
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="col-sm-3">
                          <label>Participante</label>
                          <select
                            name="participanteId"
                            className="form-control"
                            value={this.state.consulta.participanteId}
                            onChange={this.handleChange}
                          >
                            {this.state.usuarios.map(function (usuario, i) {
                              return (
                                <option key={usuario.id} value={usuario.id}>
                                  {usuario.nome}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                        <div className="col-sm-3">
                          <label>Paciente</label>
                          <input
                            placeholder="PACIENTE"
                            name="paciente"
                            type="text"
                            className="form-control"
                            value={this.state.consulta.paciente}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <div className="col-sm-12 text-right">
                          <button
                            type="submit"
                            className="btn btn-sm btn-primary mb-2"
                          >
                            Pesquisar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>,
      ]
    );
  }
}

export default Importacao;
